<template>
  <Header style="background-color: #ffffff;">
      <Menu mode="horizontal" theme="light" active-name="1">
          <div class="layout-logo"></div>
          <div class="layout-nav">
            <MenuItem name="1" :to="{path: '/'}">
                <Icon type="ios-navigate"></Icon>
                站点首页
            </MenuItem>
            <MenuItem name="2" @click="logout">
                <Icon type="ios-keypad"></Icon>
                退出登录
            </MenuItem>
          </div>
      </Menu>
      <div id="admin-menu-sep"></div>
  </Header>
  </template>

<script>

export default {
  components: {},
  data () {
    return {
      user: null
    }
  },
  mounted() {
    this.initUser()
  },
  methods: {
    //登录
    initUser() {
      let userStr = localStorage.getItem("user")
      if(userStr!=null) {
        this.user = JSON.parse(userStr)
      }
    },

    //退出登录
    logout() {
        localStorage.removeItem("user")
        this.user = null
        this.$router.push({path: '/'})
      }
    
  }
}
</script>